import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden" data-id="element-151" data-mp="ehti5t5oavm8">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold-dark/20 via-black to-black -z-10" data-id="element-152" data-mp="9lbhp5hdljfp"></div>

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-153" data-mp="1297a3xzwwp6o">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-154" data-mp="1274nlnxyxe6p">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/10 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-155" data-mp="nbyhz22sbhdw">
            📚 Spanish Teacher Ready™
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6" data-id="element-156" data-mp="3j7zgtn69y0is">
            Resolve a Full Year of Spanish Classes{' '}
            <span className="text-gold-gradient" data-id="element-157" data-mp="39acyeqprnqu2">in Just 5 MINUTES</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[260px] sm:max-w-md md:max-w-2xl mb-4 sm:mb-6" data-id="element-158" data-mp="3e960lmzlrvex">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-159" data-mp="2qhqvjmgfyzzz"></div>
          <img src="https://cdn.magicpatterns.com/uploads/skck6kLaAdm3e74NMxQNx4/seguridad_e_higiene_(4).png" alt="Spanish Teacher Ready™ — The Complete Teaching System" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-160" data-mp="2vj7u3bbgeade" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-161" data-mp="s3mfk97g6b1j">
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-2 sm:mb-3 font-semibold text-white" data-id="element-162" data-mp="deyks55fe5cn">
            Spanish Teacher Ready™ — The Complete Teaching System
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-163" data-mp="15zzubakljycb">
            The complete professional teaching library for Spanish 1 and Spanish
            2 — ready to use from today.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-164" data-mp="3lu0454qihb1b">
            <Button href="#pricing" className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-165" data-mp="3hrdacyaa5g1h">
              🟡 GET THE COMPLETE TEACHING SYSTEM NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-400" data-id="element-166" data-mp="21bfu7mc5d9sv">
            <div className="flex items-center gap-1.5" data-id="element-167" data-mp="268oeptkrppxa">
              <CheckCircle size={14} className="text-gold" data-id="element-168" data-mp="2b192oegzt8sw" />
              <span data-id="element-169" data-mp="2b2k9yo9ncyor">Complete Teaching Library</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-170" data-mp="2fzaov89pto8l">
              <CheckCircle size={14} className="text-gold" data-id="element-171" data-mp="2kyndnyk5d5dt" />
              <span data-id="element-172" data-mp="2l101gscl69ys">5 Strategic Bonuses</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-173" data-mp="2p1k060ct5ln1">
              <CheckCircle size={14} className="text-gold" data-id="element-174" data-mp="2tzlfca7450t8" />
              <span data-id="element-175" data-mp="2tz1ykwt78igs">Immediate Access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}